/* eslint-disable import/prefer-default-export */

import { CLUSTERS } from 'src/store/ActionTypes';

export const fetchSegments = (query) => ({
  type: CLUSTERS.FETCH_SEGMENTS,
  payload: query,
});

export const saveClustering = (count) => ({
  type: CLUSTERS.SAVE_CLUSTERING,
  payload: count,
});

export const setClustering = (count) => ({
  type: CLUSTERS.SET_CLUSTERING,
  payload: count,
});

export const editCluster = (id, payload) => ({
  type: CLUSTERS.EDIT_CLUSTER,
  payload: {
    id,
    payload,
  },
});
